import qs from 'qs';
import request from '../../../../shared/lib/request';
import { API } from '../../../../shared/constants';

const getAgenzie = (page, noPagination, aclEnabled, id) =>
  request({
    url: API.AGENZIA_TECNOCASA + (id ? `/${id}` : ''),
    method: 'GET',
    params: {
      pagination: !noPagination,
      page: page || 1,
      enable_acl: !!aclEnabled || false,
    },
  });

const getAllAgenzie = () =>
  request({
    url: API.AGENZIA_TECNOCASA,
    method: 'GET',
  });

const getAgenzieWithSearch = ({ page, searchText, provincia, regione, settore, collaboratore, nonAssegnate, orderField, orderDirection }) => {
  const filter = [
    provincia && {
      type: 'like',
      field: 'siglaPrv',
      value: `${provincia}`,
      where: 'and',
    },
    regione && {
      type: 'like',
      field: 'regione',
      value: `%${regione}%`,
      where: 'and',
    },
    settore && {
      type: 'like',
      field: 'settore',
      value: `${settore}`,
      where: 'and',
    },
    nonAssegnate && {
      type: 'isnull',
      field: 'collaboratore',
      where: 'and',
    },
    collaboratore && {
      type: 'eq',
      field: 'collaboratore',
      value: collaboratore,
      where: 'and',
    },
    searchText && {
      type: 'agenzia_tecnocasa_filter',
      fieldsvalues: { searchText },
    },
  ].filter(Boolean);

  return request({
    url: `${API.AGENZIA_TECNOCASA}`,
    method: 'GET',
    params: {
      page: page || 1,
      filter,
      'order-by': [
        {
          type: 'field',
          field: orderField && orderDirection !== 'none' ? orderField : 'updatedAt',
          direction: orderDirection !== 'none' && orderDirection ? orderDirection : 'desc',
        },
      ],
    },
    paramsSerializer: (params) => qs.stringify(params),
  });
};

const getAgenzieOptions = ({ aclEnabled }) =>
  getAgenzie(0, true, aclEnabled)
    .then((res) =>
      res._embedded.agenziatecnocasa.map((obj) => ({ value: obj.id, label: `${obj.agenzia} - ${obj.ragSoc}` }))
    )
    .then((data) => ({ options: data }));

const getAgenzieOptionsForDashboard = (aclEnabled) =>
  getAgenzie(0, true, aclEnabled)
    .then((res) =>
      res._embedded.agenziatecnocasa.map((el) => ({
        key: el.id,
        text: `${el.agenzia} - ${el.ragSoc}`,
        value: el.agenzia,
      }))
    )
    .then((options) => options);

const getAgenzia = (id) =>
  getAgenzie(0, true, false, id).then((res) => ({ value: res.id, label: `${res.agenzia} - ${res.ragSoc}` }));

const delAgenzia = (id) =>
  request({
    url: `${API.AGENZIA_TECNOCASA}/${id}`,
    method: 'DELETE',
  });

const get = (id) =>
  request({
    url: `${API.AGENZIA_TECNOCASA}/${id}`,
    method: 'GET',
  });

const create = (content) =>
  request({
    url: API.AGENZIA_TECNOCASA,
    method: 'POST',
    data: content,
  });

const put = (content) =>
  request({
    url: `${API.AGENZIA_TECNOCASA}/${content.id}`,
    method: 'PUT',
    data: content,
  });

const AgenziaTecnocasaService = {
  get,
  getAgenzia,
  getAgenzie,
  getAllAgenzie,
  getAgenzieOptions,
  getAgenzieWithSearch,
  delAgenzia,
  create,
  put,
  getAgenzieOptionsForDashboard,
};

export default AgenziaTecnocasaService;



// WEBPACK FOOTER //
// ./app/shared/services/api/agenziatecnocasa/index.js